module.exports = __webpack_public_path__ + "media/images/emoticons/cherry-da29643689388200e1144ac57a312b0c.gif";